function findItemByUUID(array: any[], uuid: any) {
  for (const item of array) {
    if (item.data) {
      for (const subItem of item.data) {
        if (subItem.data?.id === uuid) {
          return {
            fileName: subItem.data.fileName,
            data: subItem.data.data,
          };
        }
      }
    }
  }
  return null;
}

export default findItemByUUID;